<template>
  <div id="app">
    <router-view />
    <!-- <div class="dialog--close">
      <img src="./assets/images/close-dialog.png" />
    </div>-->
    <!-- <van-cell is-link>展示弹出层</van-cell> -->
    <!-- <van-popup v-model="show" class="dialog--close" :close-on-click-overlay="false">
      <img class="img__dialog" src="./assets/images/close-dialog.png" />
    </van-popup> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      show: true
    }
  }
}
</script>
<style>
#app {
  font-weight: 600;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dialog--close {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.dialog--close img {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.9);
}
</style>
